import { APP_VERSION } from '../app/core/constants/app.constant';

export const ENVIRONMENT = {
    production: false,
    env: 'STAGING',
    /** TPOD-516: hour-of-day at which "Dismiss for today" expires. 24 = midnight (Prod default). */
    announcementDismissResetHour: 21,
    recaptchaSiteKey: '6LfCGCsqAAAAAPdX3DzaD0V5ofndyC6u3DYc1_m1',
    apiDomain: 'https://taxpodwebapi3-e7ejgug7a0gdfkb0.southeastasia-01.azurewebsites.net',
    version: APP_VERSION,

    // Developer Note: This flag is for QA Test Case Purposes only.
    // E.g. It enables buttons that when clicked, will simulate
    // error response codes from the target API.
    // It was introduced as of 9th September 2025, thus API implmenetations
    // before that may not have this supported.
    showErrorTestCaseUI: 1,

    // Developer Note: Debug overlay configuration for the video player component.
    // When enableVideoPlayerDebugOverlay is true and the authenticated user's ID (GUID) is in
    // the videoPlayerDebugOverlayWhitelist array, a debug overlay will be shown on the video player.
    // The user ID is extracted from the JWT token's "id" claim.
    // This is useful for debugging video playback issues in non-production environments.
    enableVideoPlayerDebugOverlay: true,
    // User IDs (GUIDs) - e.g., ['66921e94-0e44-429d-a832-c72a259209e9']
    videoPlayerDebugOverlayWhitelist: [
        // client@agmostudio.com
        'b9e8caa3-a926-4c5f-9c18-b0afd5fed100'
    ] as string[],

    cryptoPublicKey:
        '-----BEGIN RSA PUBLIC KEY-----MIIBCgKCAQEA2zIEJ7E+rFhMFfu/hy/pk/f6sP5CQ7k+yWWGhYfaoEWzKarIYTZLGpGbnxdw5eJwK/XiaxXgKgGfW4Ml3eIsRxYybIAB+HtYD/Cb6Z2KOSQICF6Wbiuc3APJLVK3Bbr5MXYYgTdVgwO6HMISk2byYSA3TUzdCKa36bZWC85oo53CjP77eJXr/NAt/NzH8WfvQ3DYCOeVx2ybm3xdDUNfiwOjIdJ+NGP8FYQkQ5+W+5SWOjFJGERd8tmFkupRUEEhWHVoEq/ofZMAjyjm3G8ZtkB/H75Llc50oxd8tki3HLxk3ZYenwyNz/kcgxvY6rOmebgyKUEPH3jI+l+QL6IvIQIDAQAB-----END RSA PUBLIC KEY-----',
    stripePublicKey:
        'pk_test_51MHNbULoOuYtrpweWG9mUNXC2bzkjq6RumgbdNslrAp6FJcWzz8antVyR9c7BCmDJPD38KL5q1ITg1dVLIwPxLZe00ndCmuFtw',
    firebaseConfig: {
        apiKey: "AIzaSyBtSocUQb--_qP5HtPCq22YpqDeeswwW-Q",
        authDomain: "taxpod-dev.firebaseapp.com",
        databaseURL: "https://taxpod-dev-default-rtdb.asia-southeast1.firebasedatabase.app",
        projectId: "taxpod-dev",
        storageBucket: "taxpod-dev.appspot.com",
        messagingSenderId: "497336293357",
        appId: "1:497336293357:web:9063fdeed2fac22e59f9e4",
        measurementId: "G-N9YY8LC4HM"
    }
};